class VsFacetFiltersForm extends HTMLElement {
    constructor() {
        super();

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#VsFacetsWrapperDesktop');
        if (facetWrapper) {
            facetWrapper.addEventListener('keyup', onKeyUpEscape);
        }
    }

    static setListeners() {
        document.addEventListener('vs:facets-changed', (evt) => {
            const params = new URLSearchParams(evt.detail.query).getAll('filter.p.product_type');
            document.querySelectorAll('vs-facet-filters-form input[name="filter.p.product_type"]').forEach(el => {
                el.checked = params.includes(el.value);
                el.closest('li.vs-type-filter--item').classList.toggle('active', params.includes(el.value));
            });
        });
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    createSearchParams(form) {
        const url = new URL(window.location.href);
        const currentSearchParams = url.searchParams;
        currentSearchParams.delete('filter.p.product_type');
        const formData = new FormData(form);
        const newSearchParams = new URLSearchParams(formData);
        for (const [key, value] of newSearchParams.entries()) {
            currentSearchParams.append(key, value);
        }
        return currentSearchParams.toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForm = document.querySelector('vs-facet-filters-form form');
        const forms = [];
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(sortFilterForm));
        this.onSubmitForm(forms.join('&'), event);
    }

}

customElements.define('vs-facet-filters-form', VsFacetFiltersForm);
VsFacetFiltersForm.setListeners();